var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('closed-card',{staticClass:"papas-merge-closed-card",class:{ 'danger': _vm.isBug },attrs:{"title":_vm.title,"sub-title":_vm.cardSubtitle}})}
var staticRenderFns = []

export { render, staticRenderFns }